module.exports = __webpack_public_path__ + "img/img01.e5c7f39f.png";